import { render, staticRenderFns } from "./feedbackArchive.vue?vue&type=template&id=b89ba95c"
import script from "./feedbackArchive.vue?vue&type=script&lang=js"
export * from "./feedbackArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports